export default {
  API_URL: 'https://api.vestiario-licitacao.totalgrass.com.br/',
  CLIENT_SECRET: 'sgrKIpCpJXsn4ZBTRsdpFRNnwkzl4kLxrC8nkyo5',
  GRANT_TYPE: 'password',
  CLIENT_ID: '2',
  PUSHER_APP_KEY: '66824d8739c0181af28e',
  PUSHER_APP_CLUSTER: 'mt1',
  UPLOAD_LIMIT: 5,
};
